import $ from 'jquery';

$(document).ready(function () {
  acfExampleBlock();
});
function acfExampleBlock() {
  $('.js-acf-downloads-block').each(function () {});
}
